import useGetMe from './useGetMe';

const useGetMyAccountExternalPaymentRedirectUrl = () => {
  const { user, ...rest } = useGetMe();

  return {
    externalPaymentRedirectUrl:
      user?.account.externalPaymentRedirectUrl ?? null,
    ...rest,
  };
};

export default useGetMyAccountExternalPaymentRedirectUrl;
